import React from "react";
import type { ChatSummary } from "./types";

type ChatSelectMenuProps = {
  summaries: ChatSummary[];
  onChatSelect: (chatId: number) => void;
  onChatCreate: () => void;
  onChatDelete: (chatId: number) => void;
  activeChatId?: number;
};

export const ChatSelectMenu: React.FC<ChatSelectMenuProps> = ({
  summaries,
  onChatSelect,
  onChatCreate,
  onChatDelete,
  activeChatId,
}) => {
  const renderChatLink = (chatSummary: ChatSummary): React.JSX.Element => (
    <li
      key={chatSummary.id}
      onClick={(e) => {
        e.stopPropagation();
        onChatSelect(chatSummary.id);
      }}
      className={`tw-relative tw-cursor-pointer tw-p-2 ${
        activeChatId === chatSummary.id
          ? "tw-bg-gray-100 tw-border-l-2 tw-border-textual-blue tw-pl-3"
          : "hover:tw-bg-gray-100"
      }`}
    >
      <h3>{chatSummary.name || `ChatID - ${chatSummary.id}`}</h3>
      <span className="tw-text-sm tw-text-gray-600">
        {chatSummary.modelName}
      </span>
      <button
        onClick={(e) => {
          e.stopPropagation();
          onChatDelete(chatSummary.id);
        }}
        className="tw-absolute tw-top-4 tw-right-4 tw-p-1.5 tw-text-gray-400 hover:tw-text-primary tw-transition-colors"
        title="Delete chat"
      >
        <i className="material-icons tw-text-xl">delete</i>
      </button>
    </li>
  );

  return (
    <nav>
      <ul>
        <li
          key="first"
          onClick={onChatCreate}
          className={`tw-cursor-pointer tw-p-2 tw-rounded hover:tw-bg-gray-100`}
        >
          <h3>New +</h3>
          <span className="tw-text-sm tw-text-gray-600">
            Create an empty chat
          </span>
        </li>
        {summaries.map((summary) => renderChatLink(summary))}
      </ul>
    </nav>
  );
};
